import { useCallback } from 'react';

export default (getValues, setError, apiErrorMessage) =>
  useCallback(
    (error, mapper = {}) => {
      let errorWasUpdated = false;
      if (error.response.data) {
        const { data } = error.response;
        const values = getValues();
        const keys = Object.keys(values);
        Object.keys(data).forEach((key) => {
          let keyToCheck = key;
          if (Object.keys(mapper).includes(key)) {
            keyToCheck = mapper[key];
          }
          if (keys.includes(keyToCheck) && data[key]) {
            errorWasUpdated = true;
            setError(keyToCheck, { type: 'value', message: data[key] });
          }
        });
        if (!errorWasUpdated && data.invalidParams) {
          Object.keys(data.invalidParams).forEach((key) => {
            let keyToCheck = key;
            if (Object.keys(mapper).includes(key)) {
              keyToCheck = mapper[key];
            }
            if (keys.includes(keyToCheck) && data.invalidParams[key]) {
              errorWasUpdated = true;
              setError(keyToCheck, { type: 'value', message: data.invalidParams[key] });
            }
          });
        }
        if (!errorWasUpdated && data.message) {
          errorWasUpdated = true;
          setError('apiError', { message: apiErrorMessage || data.message });
        }
      } else {
        setError('apiError', { message: apiErrorMessage || error.message });
      }
    },
    [getValues, setError, apiErrorMessage],
  );
